import ErrorModal from "@Components/Feedback/Modal/ErrorModal";
import { ModalContextInterface } from '@Containers/ModalContainer';
import Csrf from '@Core/Csrf';
import PageVariables from '@Core/PageVariables';
import { ClientError, GraphQLClient } from 'graphql-request';
import { RequestConfig } from "~/node_modules/graphql-request/build/legacy/helpers/types";
import React from "react";

let modal: ModalContextInterface;

export const setModalActions = (actions: any) => {
    modal = actions;
};

export default function Gql(
    suffix: string = '',
    options: RequestConfig = {},
): GraphQLClient {
    if (suffix) {
        suffix = `/${suffix}`;
    }

    options.credentials = 'include';

    options.mode = 'cors';

    options.headers = {
        Accept: 'application/json',

        'X-XSRF-TOKEN': Csrf.getToken(),

        'X-Requested-With': 'XMLHttpRequest',
    };

    options.responseMiddleware = (response) => {
        if (response instanceof ClientError) {
            if (typeof modal !== 'undefined') {
                modal.setSize('lg');
                modal.open(<ErrorModal response={response.response} key={Date.now()} />);
            }
        }
    };

    return new GraphQLClient(
        `https://${PageVariables.getApiHost()}/api${suffix}`,
        options
    );
}
